/**
* Created by MARCIANO_8
* Marciano Digital Agency
* www.marciano.com.mx
* Date: 15/03/2018.
*
* layouts-create-view Vue Component
*/
<template>
  <form-modal
    :hide-secondary-button="true"
    primary-button-label="Asignar"
    modal-title="Asignar Evaluación"
    @closeModal="onCloseModal"
    @primaryButtonClick="onSave"
  >
    <div class="content">
      <assignments-form ref="form"/>
    </div>
  </form-modal>
</template>

////////////////////////////////////////////
//                                  SCRIPT
////////////////////////////////////////////
<script>
import FormModal from '@/components/_shared/form-modal'
import AssignmentsForm from '@/modules/assignments/assignments-form'

export default {
  name: 'AssignmentsCreateView',
  components: { FormModal, AssignmentsForm },
  methods: {
    onCloseModal () {
      this.$router.push({ name: 'assignments' })
    },
    onSave () {
      this.$refs.form.onSubmit()
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style
  lang="scss"
  scoped
>
.content {
  padding: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/app/assignments/assignments-create-view.vue